import { MessagingStatus, type MessagingMessage } from "@/model/messaging";
import { BaseStore } from "@deputy-ai/common/jotai";
import { type Atom, atom, type PrimitiveAtom } from "jotai";
import type { SetStateAction } from "react";

export interface MessageStoreOptions {
  message: MessagingMessage;
  file?: File;
}

export class MessageStore extends BaseStore {
  readonly messageUid: string;

  readonly #message: PrimitiveAtom<MessagingMessage>;
  get message(): Atom<MessagingMessage> {
    return this.#message;
  }

  get file() {
    return this.options.file;
  }

  uploadFileObjectName?: string;

  constructor(private readonly options: MessageStoreOptions) {
    super();

    this.messageUid = this.options.message.uid;
    this.#message = atom(this.options.message);
  }
  updateMessage(updater: SetStateAction<MessagingMessage>) {
    this.set(this.#message, updater);
  }

  markAsSending() {
    this.updateMessage((prev) => ({
      ...prev,
      status: MessagingStatus.Sending,
    }));
  }

  markAsFailed() {
    this.updateMessage((prev) => ({
      ...prev,
      status: MessagingStatus.Failed,
    }));
  }

  uploadFileSuccess(objectName: string) {
    this.uploadFileObjectName = objectName;
  }
}
